import Vue from 'vue'
import VueRouter from 'vue-router'
import firebaseUtil from '../firebase'
import Home from '../views/Home.vue'
import Rebase from '../views/Rebase.vue'
import Ranking from '../views/Ranking.vue'
import Setting from '../views/Setting.vue'
import Challenge from '../views/Challenge.vue'
import NotFound from '../views/NotFound.vue'
import About from '../views/About.vue'

firebaseUtil.init();

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'Home' },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/new',
    name: 'New',
    component: Rebase,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: Ranking,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/challenge/:cid',
    name: 'Challenge',
    component: Challenge,
  },
  {
    path: '/challenge/:cid/edit',
    name: 'Edit',
    component: Rebase,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/:userId',
    name: 'User',
    component: Home,
  },
  // もし自分のIDだったら見た目を変える
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router